import { render, staticRenderFns } from "./settingsProductIcon.vue?vue&type=template&id=2211fe27&scoped=true"
import script from "./settingsProductIcon.vue?vue&type=script&lang=js"
export * from "./settingsProductIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211fe27",
  null
  
)

export default component.exports